import { render } from "./ChatHistory.vue?vue&type=template&id=ebb66dc6&scoped=true"
import script from "./ChatHistory.vue?vue&type=script&lang=js"
export * from "./ChatHistory.vue?vue&type=script&lang=js"

import "./ChatHistory.vue?vue&type=style&index=0&id=ebb66dc6&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebb66dc6"]])

export default __exports__